/* Red Line image band: the photo settles from 1.04 to 1 the first time the band enters view.
   Only bands still below the fold get the pre-state, so nothing visible ever jumps.
   Skipped under prefers-reduced-motion or without IntersectionObserver. Safe to load twice. */
(function () {
  if (window.__paRlImageBand) return;
  window.__paRlImageBand = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (REDUCED || !('IntersectionObserver' in window)) return;

  function init() {
    var bands = document.querySelectorAll('.pa-rl-ib:not([data-rl-ib])');
    if (!bands.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -15% 0px', threshold: 0 });

    Array.prototype.forEach.call(bands, function (band) {
      band.setAttribute('data-rl-ib', '');
      if (band.getBoundingClientRect().top < window.innerHeight) return;
      band.classList.add('is-pre');
      io.observe(band);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
